<template>
  <!-- HERO full width (fondo ocupa toda la sección) -->
  <section class="hero">
    <div class="hero__inner">
      <!-- Texto -->
      <div class="hero__copy">
        <h1 class="hero__title">TU INFORMACIÓN<br />MÉDICA EN SEGUNDOS</h1>
        <p class="hero__subtitle">
          Accede a datos esenciales en<br />
          emergencias mediante tecnología<br />
          NFC y QR.
        </p>
      </div>

      <!-- Imagen de enfermero a la derecha -->
      <div class="hero__nurse">
        <img src="../assets/IMG/Enfermero.png" alt="Enfermero" />
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "WelcomeView" };
</script>

<style scoped>
/* ====== HERO FULL WIDTH ======
   Esto hace que el fondo se salga del container y ocupe 100% del viewport */
.hero {
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  margin-top: 86px;

  min-height: clamp(580px, 62vw, 860px);
  overflow: hidden;

  background-color: #fff;
  background-image: url("../assets/IMG/fondo2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 82.1% auto;

  padding-left: 8vw;
  padding-right: 8vw;
}

/* Contenido centrado dentro del hero */
.hero__inner {
  position: relative;
  min-height: inherit;
  height: 100%;
  width: 100%;
  margin: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: clamp(22px, 3.2vw, 54px) clamp(10px, 2.8vw, 38px);
}

/* ====== TEXTO ====== */
.hero__copy {
  width: min(560px, 46%);
  margin-left: clamp(22px, 4vw, 72px);
  transform: translateY(36px);
  z-index: 3;
  color: #1A237E;
}

.hero__copy h2 {
  color: #ffffff;
  font-family: "Barlow", sans-serif;
  font-size: clamp(36px, 4.8vw, 72px);
  font-weight: 300;
  margin: 0;
  letter-spacing: 0.06em;
  line-height: 1;
  text-transform: uppercase;
}

.hero__copy h1 {
  color: #ffffff;
  font-family: "Barlow", sans-serif;
  font-size: clamp(42px, 6.2vw, 90px);
  font-weight: 400;
  margin: 0;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.035em;
}

.hero__copy h1 strong {
  font-weight: 700;
}

.hero__copy p {
  font-family: "Barlow", sans-serif;
  color: #ffffff;
  font-weight: 400;
  margin: 18px 0 0;
  font-size: clamp(20px, 2.2vw, 34px);
  line-height: 1.1;
  max-width: 520px;
}

/* ====== MASCOTAS (derecha) ====== */
.hero__pets {
  position: absolute;
  right: -40px;
  bottom: 20px;
  width: min(38%, 500px);
  height: 100%;
  z-index: 2;

  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

/* “Capsule” clara detrás de las mascotas */
.hero__pets::after {
  content: "";
  position: absolute;
  right: -2%;
  bottom: 11%;
  width: 108%;
  height: 56%;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  z-index: 1;
}

.hero__pets img {
  position: relative;
  z-index: 2;
  height: 68%;
  width: auto;
  object-fit: contain;
  transform: translateY(14px);
  filter: drop-shadow(0 22px 45px rgba(0, 0, 0, 0.25));
}

/* Imagen de enfermero a la derecha (DESKTOP/TABLET) */
.hero__nurse {
  position: absolute;
  right: -15vw;
  bottom: -11.6vw;
  top: auto;
  display: flex;
  align-items: flex-end;
  z-index: 2;
}

.hero__nurse img {
  width: 1400px;
  height: 1400px;
  max-width: 140vw;
  max-height: 140vh;
  object-fit: contain;
  transform: none;
  transform-origin: center bottom;
}

/* ====== RESPONSIVE ====== */
@media (max-width: 1200px) {
  .hero {
    min-height: clamp(540px, 64vw, 780px);
  }

  .hero__copy {
    width: min(620px, 58%);
  }

  .hero__pets {
    width: min(42%, 470px);
    right: -24px;
    bottom: 6px;
  }

  .hero__pets img {
    height: 66%;
  }
}

/* TABLET */
@media (min-width: 768px) and (max-width: 1024px) {
  .hero__nurse img {
    width: 900px !important;
    max-width: 95vw !important;
    height: auto !important;
    max-height: 95vh !important;
    object-fit: contain !important;
  }
  .hero {
    margin-top: 78px;
    min-height: 700px;
  }

  .hero__inner {
    padding: 24px 20px;
  }

  .hero__copy {
    width: 56%;
    margin-left: 20px;
    transform: translateY(120px) !important;
    text-align: left;
  }

  .hero__copy h2 {
    font-size: clamp(28px, 5vw, 40px);
    margin-top: 80px;
  }

  .hero__copy h1 {
    font-size: clamp(48px, 8vw, 90px);
    letter-spacing: 0.02em;
    margin-top: 80px;
  }

  .hero__copy p {
    max-width: 92%;
    font-size: clamp(16px, 2.6vw, 22px);
  }

  .hero__pets {
    width: 46%;
    right: -10px;
    bottom: -22px;
  }

  .hero__pets::after {
    width: 106%;
    height: 46%;
    bottom: 12%;
  }

  .hero__pets img {
    height: 58%;
    transform: translateY(14px);
  }
}

/* ====== MÓVIL ====== */
@media (max-width: 900px) {
  .hero {
    min-height: 84svh;
    height: 84svh;
    margin-top: 72px;
    padding-left: 0;
    padding-right: 0;
    background-color: #fff;
    background-image: url("~@/assets/IMG/fondo.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center bottom;
  }

  .hero__inner {
    position: relative;
    height: 100%;
    min-height: 0;
    padding: 20px 16px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .hero__copy {
    width: min(560px, 92%);
    margin: 0 auto;
    transform: none !important;
    text-align: center;
    z-index: 4;
    color: #004b5c;
  }

  .hero__title {
    margin: 0;
    font-family: "Barlow", sans-serif;
    font-weight: 700;
    line-height: 1.08;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    font-size: clamp(26px, 7.4vw, 40px);
    color: #004b5c !important;
  }

  .hero__subtitle {
    margin: 10px 0 0;
    font-family: "Barlow", sans-serif;
    font-weight: 400;
    line-height: 1.18;
    font-size: clamp(14px, 4.2vw, 20px);
    max-width: 28ch;
    color: #004b5c !important;
  }

  /* Enfermero fijo abajo y centrado */
  .hero__nurse {
    position: absolute;
    left: 50%;
    bottom: -24px;
    transform: translateX(-50%);
    right: auto;
    top: auto;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 10;
    pointer-events: none;
  }

  .hero__nurse img {
    width: 128vw;
    height: auto;
    max-width: none;
    max-height: none;
    object-fit: contain;
    transform: scale(1.24);
    transform-origin: center bottom;
  }
}

/* móviles pequeños */
@media (max-width: 480px) {
  .hero {
    min-height: 88svh;
    height: 88svh;
  }

  .hero__subtitle {
    max-width: 26ch;
  }

  .hero__nurse {
    bottom: -28px;
  }

  .hero__nurse img {
    width: 132vw;
    transform: scale(1.30);
  }
}

/* móviles tipo 390 a 413 */
@media (min-width: 390px) and (max-width: 413px) {
  .hero__nurse {
    bottom: -34px;
  }

  .hero__nurse img {
    width: 145vw !important;
    transform: scale(1.48) !important;
  }
}

/* móviles tipo 414 a 430 */
@media (min-width: 414px) and (max-width: 430px) {
  .hero__nurse {
    bottom: -40px;
  }

  .hero__nurse img {
    width: 152vw !important;
    transform: scale(1.58) !important;
  }
}

/* iPad Pro 12.9" vertical */
@media (width: 1024px) and (height: 1366px) {
  .hero {
    margin-top: 86px;
    min-height: clamp(580px, 62vw, 860px);
    padding-left: 8vw;
    padding-right: 8vw;
    background-size: 82.1% auto;
    background-position: center;
  }

  .hero__inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: clamp(22px, 3.2vw, 54px) clamp(10px, 2.8vw, 38px);
  }

  .hero__copy {
    width: min(560px, 46%);
    margin-left: clamp(22px, 4vw, 72px);
    transform: translateY(2px) !important;
    text-align: left;
    color: #1A237E;
  }

  .hero__copy h1 {
    font-size: clamp(36px, 5vw, 70px);
    margin-top: 0;
    color: #fff;
    letter-spacing: 0.035em;
  }

  .hero__copy h2 {
    font-size: clamp(28px, 3.6vw, 48px);
    margin-top: 0;
  }

  .hero__copy p {
    margin: 18px 0 0;
    font-size: clamp(20px, 2.2vw, 34px);
    line-height: 1.1;
    max-width: 520px;
    color: #fff;
  }

  .hero__nurse {
    position: absolute;
    right: -15vw;
    bottom: -19vw;
    top: auto;
    display: flex;
    align-items: flex-end;
    z-index: 2;
    left: auto;
    transform: none;
    width: auto;
    justify-content: flex-end;
    pointer-events: auto;
  }

  .hero__nurse img {
    width: 2200px !important;
    height: 2200px !important;
    max-width: 80vw !important;
    max-height: 80vh !important;
    object-fit: contain;
    transform: none;
  }
  /* ====== BREAKPOINT 412x915: BAJAR TEXTOS ====== */
@media (width: 412px) and (height: 915px) {
  .hero__copy {
    margin-top: 80px !important;
  }
}
}
</style>

